"use client";

import { convertToAssetId, HydratedAgent } from "@zapier/client";
import { MoveAssetModal } from "@zapier/shared";
import { AssetTypes } from "@zapier/utils";
import { useCallback, useMemo } from "react";
import { AgentDeleteModal } from "../AgentDeleteModal";

export enum AgentModal {
  Delete = "agent__delete",
  ChangeOwner = "agent__changeOwner",
  Share = "agent__share",
  Move = "agent__move",
}

interface Props {
  currentAgent: HydratedAgent | undefined;
  currentModal: AgentModal | undefined;
  folderId?: string; // used for cache invalidation in mutations
  setCurrentAgent: (agent?: HydratedAgent | undefined) => void;
  setCurrentModal: (modal?: AgentModal | undefined) => void;
}

export function AgentModals({
  currentAgent,
  currentModal,
  folderId,
  setCurrentAgent,
  setCurrentModal,
}: Props) {
  const handleCloseModal = useCallback(() => {
    setCurrentModal();
    setCurrentAgent(undefined);
  }, [setCurrentAgent, setCurrentModal]);

  const assetIds = useMemo(() => {
    if (!currentAgent?.id) {
      return;
    }
    return [convertToAssetId(AssetTypes.Agent, currentAgent.id)];
  }, [currentAgent?.id]);

  return (
    <>
      <AgentDeleteModal
        agent={currentAgent}
        folderId={folderId}
        isOpen={currentModal === AgentModal.Delete}
        onClose={handleCloseModal}
      />

      <MoveAssetModal
        assetIds={assetIds}
        assetParentId={folderId}
        assetTitle={currentAgent?.name}
        assetType={AssetTypes.Agent}
        isOpen={currentModal === AgentModal.Move}
        setIsOpen={handleCloseModal}
      />
    </>
  );
}
